import { trackPublicEvent } from "@/features/analytics/api";
import type {
  EventPrefix,
  GoogleTagManagerEventDetails,
} from "@/features/analytics/models";
import {
  CUSTOMER_IO_EVENT,
  EVENT_PREFIX,
  GOOGLE_TAG_MANAGER_EVENT,
} from "@/features/analytics/models";
import { triggerGoogleTagManagerTracking } from "@/features/analytics/triggers";

interface TrackBillingAddressStartedParams {
  userId?: string;
  eventPrefix?: EventPrefix;
}

export const trackBillingAddressStarted = ({
  userId,
  eventPrefix = EVENT_PREFIX.NONE,
}: TrackBillingAddressStartedParams = {}) => {
  triggerGoogleTagManagerTracking<GoogleTagManagerEventDetails>({
    event: `${eventPrefix}${GOOGLE_TAG_MANAGER_EVENT.BILLING_ADDRESS_STARTED}`,
  });

  trackPublicEvent({
    event: `${eventPrefix}${CUSTOMER_IO_EVENT.BILLING_ADDRESS_STARTED}`,
    properties: { source: window.location.href },
    userId,
  });
};
